
const CustomerFeeback = () => {
  return (
    <div className="bg-no-repeat  bg-AdviceBg font-[Inter] bg-cover relative sm:mx-14 mb-10">
      <div className="absolute inset-0 bg-[#000000dF] "></div>
      <div className="relative z-10">
      <div className=" transform   p-2 sm:p-28  flex flex-col items-center gap-8 text-white text-center">
        <div className="h-1 w-14 bg-[#004C97] sm:mb-5"></div>
        <h2 className="font-bold sm:text-7xl sm:leading-[0.7] text-3xl">
          Student Feedback & Testimonials
        </h2>
        <p className="text-sm">
          At Maqrahaatu Tanzeel, our students’ success speaks for itself! Here’s
          what our learners from around the world have to say about their
          journey with us:
        </p>
      </div>
      </div>
    </div>
  );
};

export default CustomerFeeback;
